import React, { useState, useEffect } from 'react';
import { Container, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEdit, FaTrashAlt } from 'react-icons/fa';
import '../../Styles/yellocalfcss/ViewInvoice.css';
const ViewInvoice = () => {
   const navigate = useNavigate();
  const [filters, setFilters] = useState({
    student: '',
    academicYear: ''
  });

  const [generateInvoice, setGenerateInvoice] = useState(false);
  const [message, setMessage] = useState('');

  const handleClear = () => {
    setFilters({
      student: '',
      academicYear: ''
    });
    setMessage("Filters cleared!");
  };

  const handleCollectFee = () => {
    setMessage("Collect Fee clicked!");
  };

  const handleSelectStudents = () => {
    setMessage("Select Students clicked!");
  };

  const handleSpecialFees = () => {
    setMessage("Special Fees clicked!");
  };

  const handleGenerateInvoiceToggle = () => {
    setGenerateInvoice(!generateInvoice);
  };

  const sampleData = [
    { id: 1, invoiceId: 'MH20ER4534', student: 'Ashutosh Kumar', academicYear: '2023-2024', demandDate: 'Mon May 12 2025', dueDate: 'Mon May 12 2025', amountTotal: 25335, amountPaid: 0, balance: 25335, status: 'Upcoming' },
    { id: 2, invoiceId: 'MH02MN0098', student: 'Priya Sharma', academicYear: '2023-2024', demandDate: 'Mon May 12 2025', dueDate: 'Mon May 12 2025', amountTotal: 25335, amountPaid: 0, balance: 25335, status: 'Upcoming' },
    { id: 3, invoiceId: 'MH03AS3945', student: 'Rahul Singh', academicYear: '2023-2024', demandDate: 'Mon May 12 2025', dueDate: 'Mon May 12 2025', amountTotal: 25335, amountPaid: 0, balance: 25335, status: 'Upcoming' },
    { id: 4, invoiceId: 'MH04KL0921', student: 'Anjali Patel', academicYear: '2023-2024', demandDate: 'Mon May 12 2025', dueDate: 'Mon May 12 2025', amountTotal: 25335, amountPaid: 0, balance: 25335, status: 'Upcoming' },
    { id: 5, invoiceId: 'MH05MH5932', student: 'Vikash Yadav', academicYear: '2023-2024', demandDate: 'Mon May 12 2025', dueDate: 'Mon May 12 2025', amountTotal: 25300, amountPaid: 0, balance: 25300, status: 'Upcoming' }
  ];

  useEffect(() => {
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div className="upcoming-invoices-primary-wrapper">
      <Container fluid className="upcoming-invoices-container-wrapper">
        <div className="upcoming-invoices-header-section">
          <h1 className="upcoming-invoices-title-label">Upcoming Fee Invoices</h1>
          <div className="upcoming-invoices-controls-section">
            <Button  className="upcoming-invoices-collect-btn"   onClick={() => navigate("/CollectFee")}>
              Collect Fee
            </Button>
            <Button  className="upcoming-invoices-select-btn"  onClick={() => navigate("/SelectStudent")}>
              Select Students
            </Button>
            <Button  className="upcoming-invoices-special-btn"  onClick={() => navigate("/SpecialFees")}>
              Special Fees
            </Button>
            <Button  className="upcoming-invoices-select-duplicate-btn"  onClick={() => navigate("/CollectFee")}>
              Select Students
            </Button>
            <div className="upcoming-invoices-toggle-section">
              <span className="upcoming-invoices-toggle-label">Generate Invoice:</span>
              <div className="upcoming-invoices-switch-wrapper">
                <Form.Check
                  type="switch"
                  id="upcoming-invoices-switch"
                  checked={generateInvoice}
                  onChange={handleGenerateInvoiceToggle}
                  className="upcoming-invoices-switch-input"
                />
                <span className={`upcoming-invoices-switch-status ${generateInvoice ? 'upcoming-invoices-status-yes' : 'upcoming-invoices-status-no'}`}>
                  {generateInvoice ? 'YES' : 'NO'}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="upcoming-invoices-filter-section">
          <div className="upcoming-invoices-filter-controls">
            <Form.Select
              className="upcoming-invoices-select-student"
              value={filters.student}
              onChange={(e) => setFilters({ ...filters, student: e.target.value })}
            >
              <option value="">Select Student</option>
              <option value="student1">Student 1</option>
              <option value="student2">Student 2</option>
            </Form.Select>
            <Form.Select
              className="upcoming-invoices-select-year"
              value={filters.academicYear}
              onChange={(e) => setFilters({ ...filters, academicYear: e.target.value })}
            >
              <option value="">Select Academic Year</option>
              <option value="2022-2023">2022-2023</option>
              <option value="2023-2024">2023-2024</option>
            </Form.Select>
          </div>
        </div>

        {message && (
          <div className="upcoming-invoices-message-alert">
            {message}
          </div>
        )}

        <div className="upcoming-invoices-table-header-row">
          <div className="upcoming-invoices-grid-layout">
            <div className="upcoming-invoices-header-cell">#</div>
            <div className="upcoming-invoices-header-cell">Invoice ID</div>
            <div className="upcoming-invoices-header-cell">Student</div>
            <div className="upcoming-invoices-header-cell">Academic Year</div>
            <div className="upcoming-invoices-header-cell">Demand Date</div>
            <div className="upcoming-invoices-header-cell">Due Date</div>
            <div className="upcoming-invoices-header-cell">Amount Total</div>
            <div className="upcoming-invoices-header-cell">Amount Paid</div>
            <div className="upcoming-invoices-header-cell">Balance</div>
            <div className="upcoming-invoices-header-cell upcoming-invoices-action-header">
              <Button onClick={handleClear} className="upcoming-invoices-clear-button">
                Clear
              </Button>
            </div>
          </div>
        </div>

        <div className="upcoming-invoices-data-rows-wrapper">
          {sampleData.map((item, index) => (
            <div key={item.id} className="upcoming-invoices-row-card">
              <div className="upcoming-invoices-grid-layout">
                <div className="upcoming-invoices-data-cell">{index + 1}</div>
                <div className="upcoming-invoices-data-cell">{item.invoiceId}</div>
                <div className="upcoming-invoices-data-cell">{item.student}</div>
                <div className="upcoming-invoices-data-cell">{item.academicYear}</div>
                <div className="upcoming-invoices-data-cell">{item.demandDate}</div>
                <div className="upcoming-invoices-data-cell">{item.dueDate}</div>
                <div className="upcoming-invoices-data-cell">${item.amountTotal}</div>
                <div className="upcoming-invoices-data-cell">${item.amountPaid}</div>
                <div className="upcoming-invoices-data-cell">${item.balance}</div>
                <div className="upcoming-invoices-data-cell upcoming-invoices-action-cell">
                  <button
                    className="upcoming-invoices-action-icon"
                    title="View Details"
                    onClick={() => setMessage(`View Invoice: ${item.invoiceId}`)}
                  >
                    <FaEye />
                  </button>
                  <button
                    className="upcoming-invoices-action-icon"
                    title="Edit Invoice"
                    onClick={() => setMessage(`Edit Invoice: ${item.invoiceId}`)}
                  >
                    <FaEdit />
                  </button>
                  <button
                    className="upcoming-invoices-action-icon"
                    title="Delete Invoice"
                    onClick={() => setMessage(`Delete Invoice: ${item.invoiceId}`)}
                  >
                    <FaTrashAlt />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default ViewInvoice;
